import { useAnyCompassEmbed } from '../contexts/EmbedContext'
import { isEmbeddedContext } from '../helpers/embedContext'
import { isPatientNameMismatch } from '../helpers/patientMismatch'

// 「この画面は SSoT (deeplink の患者) と食い違っているか」の判定 1 本。
// 表示 (PatientMismatchBanner) と終端操作の抑止 (転記) が同じ判定を共有するための切り出し。
// 不一致の証拠があるときだけ true (判定不能は false)。性質は helpers/patientMismatch.ts。
export const usePatientMismatch = (
  patientName: string | null | undefined
): boolean => {
  const { deeplinkPatientName, patientContext } = useAnyCompassEmbed()
  // 同期判定を使う。pin (isEmbedded) を待つと INIT が来ない世代でガードが死ぬ。
  const embedded = isEmbeddedContext()
  if (!embedded) return false
  return (
    // 開いた薬歴が SSoT と違う = 別患者の記録を表示している (landing の誤オープン等)。
    isPatientNameMismatch(deeplinkPatientName, patientName) ||
    // INIT が SSoT と違う = 親が別患者へ移った。この iframe セッションはもう無効。
    isPatientNameMismatch(deeplinkPatientName, patientContext?.knjName)
  )
}
